const runAnalytics = (analyticsFunction) => {
    try {
        window.runAnalytics?.(analyticsFunction);
    }
    catch (error) {
        console.error(error);
    }
};
const setInitialDataLayer = ({ division = 'Commercial', brand, journeyName, tagVersion = '1', pageRole = 'Sales', presentation = 'Responsive', productName = 'Current Accounts', subProductName = 'Business Account', authStatus = true, journeyProduct = '', journeyProductID = '1', applicationId, }) => {
    runAnalytics((analytics) => {
        analytics.data
            .setJourney(journeyName, tagVersion)
            .setBrand(brand)
            .setDivision(division)
            .setPresentation(presentation)
            .setProduct(productName, subProductName)
            .setChannel('Online', null, null, authStatus)
            .setJourneyProduct(journeyProduct, journeyProductID)
            .setPageRole(pageRole)
            .setApplicationID(applicationId);
    });
};
const setOnPageDataLayer = ({ journeyStep, journeyStatus, journeyProduct, journeyProductID = '1', journeyDetail, }) => {
    setTimeout(() => {
        const [stepNumber, stepName] = journeyStep;
        const analyticsStepNumber = typeof stepNumber === 'number' ? stepNumber.toString() : stepNumber;
        runAnalytics((analytics) => {
            analytics.data
                .setJourneyStep(analyticsStepNumber, stepName)
                .setJourneyStatus(...journeyStatus)
                .setJourneyProduct(journeyProduct, journeyDetail, journeyProductID)
                .done()
                .events.pageView()
                .send();
        });
    }, 0);
};
const captureFieldValue = (taggingLabel, value) => {
    runAnalytics((analytics) => {
        analytics.events
            .fieldUpdate(taggingLabel)
            .captureInput(taggingLabel, value)
            .send();
    });
};
export { captureFieldValue, runAnalytics, setInitialDataLayer, setOnPageDataLayer, };
//# sourceMappingURL=webAnalytics.js.map